// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bgr_a bhv_un bhv_cw bhv_a","MenuItem__Btn":"bgr_b bhv_z"};